import { createFileRoute } from '@tanstack/react-router'
import { PosScreen } from '@/features/pos/pos-screen'

/// Каса вміє відкритися з готовим кошиком: інші екрани обіцяють «На касу» з
/// позицією і клієнтом, і доти каса відкривалась порожньою — рецепціоніст при
/// клієнті набирав тариф і знижку наново, з памʼяті.
///
/// В адресі лише ІДЕНТИФІКАТОРИ. Ні ціни, ні назви: сума, взята з URL, — це
/// сума, яку може переписати будь-хто, а каса за неї потім фіскалізує чек.
export type PosSearch = {
  /// Позиція прайсу (`pass-unlim-30`, `single-visit`, …).
  item?: string
  /// Варіант продовження абонемента (`up90`, `loyal`, …) — своя ціна, не з прайсу.
  offer?: string
  /// Кого обслуговуємо: касу відкривають із картки клієнта або з чекіну.
  client?: string
  /// Відкрити «Чеки й повернення» одразу. Ставить картка клієнта: повернення
  /// оформлюється по ЧЕКУ, а не по абонементу, тож єдина чесна дорога з картки
  /// — привести людину туди, де чеки зміни (D71).
  refund?: string
}

/// Порожній параметр — це відсутній параметр, а не порожній рядок: `?client=`
/// не має означати «обслуговуємо клієнта з порожнім іменем».
const pick = (search: Record<string, unknown>, key: keyof PosSearch): PosSearch => {
  const value = search[key]
  return typeof value === 'string' && value.trim() !== '' ? { [key]: value } : {}
}

export const Route = createFileRoute('/_app/pos')({
  component: PosScreen,
  validateSearch: (search: Record<string, unknown>): PosSearch => ({
    ...pick(search, 'item'),
    ...pick(search, 'offer'),
    ...pick(search, 'client'),
    ...pick(search, 'refund'),
  }),
})
